import React, { Component } from "react";
import i18n from 'i18next'
import './ContactUs.css'

export default class ContactUS extends Component<any, any> {
  constructor(props: any) {
    super(props)
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.lang !== this.props.lang) {
        this.props.history.push('/contactus?lang=' + nextProps.lang + '&cc=' + nextProps.cc);
    }
}

  render() {
    return (
      <div className='ContactUs-Modal' style={{ fontSize: this.props.fontSize || "100%" }}>
        <div className="Modal-title">
          {i18n.t("Common.Contact")}
        </div>
        <div className='body'>
          <div className="title">{i18n.t("Common.ContactMe.HK.title")}</div>
          <div className="description">{i18n.t("Common.ContactMe.HK.content")}<a href="mailto:enquiry_csc@bochk.com">{i18n.t("Common.ContactMe.HK.emailAddress")}</a></div>
          <table>
            <tbody>
              <tr>
                <td className="col1">{i18n.t("Common.ContactMe.HK.table.row1.title")}</td>
                <td className="col2">{i18n.t("Common.ContactMe.HK.table.row1.day1")}</td>
                <td className="col3">{i18n.t("Common.ContactMe.HK.table.row1.time1")}</td>
              </tr>
              <tr>
                <td className="col1"></td>
                <td className="col2">{i18n.t("Common.ContactMe.HK.table.row1.day2")}</td>
                <td className="col3">{i18n.t("Common.ContactMe.HK.table.row1.time2")}</td>
              </tr>
              <tr>
                <td className="col1"></td>
                <td className="col2">{i18n.t("Common.ContactMe.HK.table.row1.day3")}</td>
                <td className="col3">{i18n.t("Common.ContactMe.HK.table.row1.time3")}</td>
              </tr>
              <tr>
                <td className="col1">{i18n.t("Common.ContactMe.HK.table.row2.title")}</td>
                <td className="col2">{i18n.t("Common.ContactMe.HK.table.row2.day1")}</td>
                <td className="col3"></td>
              </tr>
            </tbody>
          </table>
          <div><br /></div>
          <div className="title">{i18n.t("Common.ContactMe.BN.title")}</div>
          <div className="description">{i18n.t("Common.ContactMe.BN.content")}<a href="mailto:inquiry@boci.com.hk">{i18n.t("Common.ContactMe.BN.emailAddress")}</a></div>
          <table>
            <tbody>
              <tr>
                <td className="col1">{i18n.t("Common.ContactMe.BN.table.row1.title")}</td>
                <td className="col2">{i18n.t("Common.ContactMe.BN.table.row1.day1")}</td>
                <td className="col3">{i18n.t("Common.ContactMe.BN.table.row1.time1")}</td>
              </tr>
              <tr>
                <td className="col1"></td>
                <td className="col2">{i18n.t("Common.ContactMe.BN.table.row1.day2")}</td>
                <td className="col3">{i18n.t("Common.ContactMe.BN.table.row1.time2")}</td>
              </tr>
              <tr>
                <td className="col1"></td>
                <td className="col2"></td>
                <td className="col3">{i18n.t("Common.ContactMe.BN.table.row1.remark")}</td>
              </tr>
              <tr>
                <td className="col1"></td>
                <td className="col2">{i18n.t("Common.ContactMe.BN.table.row1.day3")}</td>
                <td className="col3">{i18n.t("Common.ContactMe.BN.table.row1.time3")}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}